export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Растау қажет"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацияны бір реттік кілтпен растау қажет"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацияны сиқырлы сөзбен растау қажет"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тіркеуді SMS хабарламасынан алынған кодпен растау қажет"])}
}